<template>
  <div>
    <div id="messages" role="alert" style="display: none;"></div>
    <div id="renderer" v-if="!isDynamic"></div>
    <DynamicComponent v-else :templateId="templateId" :key="componentKey"></DynamicComponent>

    <div class="loading-background" v-if="loading" rounded="sm">
      <span class="loader"></span>
      <br>
      <h3>Daten werden gesendet....</h3>
    </div>
  </div>
</template>

<script>
import { Formio } from "formiojs";
import DynamicComponent from "./DynamicComponent.vue";
import config from "../config/config.js";
import axios from "axios";

export default {
  name: "FormRenderer",
  components: {
    DynamicComponent
  },
  props: {
    templateId: {
      type: [Number, String],
      required: true
    },
    isDynamic: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    sessionId: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    translations: {
      type: Object,
      default: () => ({})
    },
    language: {
      type: String,
      default: 'de'
    }
  },
  data() {
    return {
      formioForm: null,
      loading: false,
      componentKey: Date.now()
    };
  },
  mounted() {
    if (!this.isDynamic) {
      this.initFormio();
    }
  },
  methods: {
    initFormio() {
      const self = this;
      
      // Ensure authorization headers
      axios.defaults.headers.common["Authorization"] = `Bearer ${this.token}`;
      
      // Get form data from API
      axios
        .get(`${config.API_URL}/api/form/${this.templateId}`)
        .then(response => {
          if (response.status === 200) {
            const formData = response.data;
            this.renderForm(formData);
          }
        })
        .catch(error => {
          console.error("Error fetching form data:", error);
        });
    },
    
    renderForm(formData) {
      // Cleanup existing form if any
      if (this.formioForm) {
        this.formioForm.destroy();
      }
      
      // Create new form
      Formio.createForm(document.getElementById("renderer"), formData, {
        language: this.language,
        i18n: this.translations
      }).then(form => {
        this.formioForm = form;
        
        // Set up event listeners
        form.on("submit", this.handleSubmit);
        form.on("error", this.handleError);
        
        // Emit ready event
        this.$emit("form-ready", form);
      });
    },
    
    handleSubmit(submission) {
      this.loading = true;
      this.$emit("form-submit", submission);
    },
    
    handleError(errors) {
      this.loading = false;
      this.$emit("form-error", errors);
    },
    
    refreshComponent() {
      this.componentKey = Date.now();
    }
  },
  watch: {
    language(newVal) {
      if (this.formioForm && !this.isDynamic) {
        this.formioForm.language = newVal;
        this.formioForm.redraw();
      } else if (this.isDynamic) {
        this.refreshComponent();
      }
    }
  }
}
</script>

<style scoped>
.loading-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #333;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style> 